<template>
    <div class="inner">
        <div class="inner-left battery-block">
            <div class="battery-block-main">
                <div class="battery-block-main-con">
                    <div class="chart-con">
                        <div class="chart-title">
                            <div class="chart-title-main">
                                <span>年龄</span>
                            </div>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart1"></div>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div class="chart-title">
                            <div class="chart-title-main">
                                <span>党派</span>
                            </div>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-right battery-block">
            <div class="battery-block-main">
                <div class="battery-block-main-con">
                    <div class="chart-con">
                        <div class="chart-title">
                            <div class="chart-title-main">
                                <span>学历</span>
                            </div>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart3"></div>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div class="chart-title">
                            <div class="chart-title-main">
                                <span>行政级别</span>
                            </div>
                        </div>
                        <div class="chart-con-main">
                            <div class="chart" id="chart4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-center">
            <div class="member-count-block">
                <div class="item">
                    <dl>
                        <dt>理事会人数</dt>
                        <dd>{{ usersumData.lshCount }}</dd>
                    </dl>
                </div>
                <div class="item">
                    <dl>
                        <dt>常务理事会人数</dt>
                        <dd>{{ usersumData.clshCount }}</dd>
                    </dl>
                </div>
                <div class="item">
                    <dl>
                        <dt>负责人人数</dt>
                        <dd>{{ usersumData.fzrCount }}</dd>
                    </dl>
                </div>
            </div>
            <div class="sex-ratio">
                <div class="sex-ratio-main">
                    <span class="sex-name male"></span>
                    <span class="sex-name female"></span>
                    <div class="sex-ratio-bar" id="_sexRatioBar">
                        <div class="man-radio">
                            <div class="ratio-bar" :style="'width:'+sexData.manPerc">
                                <div class="ratio-bar-main" :style="'width:'+currBarW"></div>
                            </div>
                            <span class="indictor-light" :style="'left:'+sexData.manPerc"></span>
                            <div class="number">
                                <div class="count">
                                    {{ sexData.manCount }}
                                </div>
                                <div class="ratio">
                                    {{ sexData.manPerc }}
                                </div>
                            </div>
                        </div>
                        <div class="female-radio">
                            <div class="ratio-bar" :style="'width:'+sexData.womenPerc">
                                <div class="ratio-bar-main" :style="'width:'+currBarW"></div>
                            </div>
                            <div class="number">
                                <div class="count">
                                    {{ sexData.womenCount }}
                                </div>
                                <div class="ratio">
                                    {{ sexData.womenPerc }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="professional-block">
                <div class="professional-main">
                    <div class="title">
                        职称
                    </div>
                    <div class="canvas-con">
                        <div class="chart" id="chartWord"></div>
                    </div>
                </div>
                <!-- <div id="tags" style="display: none">
                    <ul>
                        <li v-for="(item,index) of positionsTitleCount" :key="index">
                            <a href="javascript:;">
                                {{ item.name }}
                            </a>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    /* eslint-disable */
    import "@/assets/script/tagcanvas.js";
    import "echarts-wordcloud";
    import {usersum, memberAge, memberEdu, organizationType, usergroup, xhlishi} from "@/assets/scripts/api/xhqj"
    const PIE_COLORS = ["#FB058F", "#00CCFF", "#0078FF", "#344DD5", "#EF9412", "#30CF70", '#2FCF6F'];
    const TEXT_COLOR = '#B6C8FF';
    export default {
        name: 'LiShiHuiChengYuan',
        components: {
            //IconTitle
        },
        data() {
            return {
                // 默认的总共的数据
                pageData: {},
                usersumData: {},
                // 年龄数据
                memberAgeData: {},
                // 理事会成员分组情况
                userGroupData: {},
                sexData: {},
                // 职称名称
                positionsTitleCount: [],
                xhlishiData: {},
                currBarW: "600px"
            }
        },
        mounted() {
            this.init();
            this.getCurrBarSize();
        },
        beforeCreate(){
            document.querySelector("#app").className += ' has-map-bg';
        },
        beforeDestroy(){
            document.querySelector("#app").className = '';
        },
        methods: {
            getCurrBarSize() {
                var $bar = document.querySelector("#_sexRatioBar");

                this.currBarW = $bar.offsetWidth + 'px';
            },
            // 获取初始的图表数据
            async getInitChartData() {
                const {data: usersumData} = await usersum();
                // const {data:memberAgeData} = await memberAge();
                // const {data:memberEduData} = await memberEdu();
                // const {data:organizationTypeData} = await organizationType();
                const {data: {positionsTitleCount, ...rest}} = await usergroup();
                const {data: xhlishiData} = await xhlishi();

                this.pageData = rest;
                this.usersumData = usersumData;
                this.positionsTitleCount = positionsTitleCount;
                this.xhlishiData = xhlishiData;
                this.$nextTick(() => {
                    this.initTagCloud();
                });
            },
            initTagCloud() {
                const chart = echarts.init(document.getElementById("chartWord"));
                const {positionsTitleCount} = this;
                const data = positionsTitleCount.map((item)=>{
                    item.value = item.num;
                    return item;
                })
                let colorIndex = 0;
                chart.setOption({

                    series: [{
                        type: 'wordCloud',
                        shape: 'circle',
                        left:'center',
                        top:'center',
                        right:null,
                        bottom:null,
                        //maskImage: maskImage,
                        width: '100%',
                        height: '90%',
                        sizeRange: [16, 70],

                        rotationRange: [0, 90],
                        rotationStep: 45,
                        gridSize: 16,
                        drawOutOfBound: false,
                        textStyle: {
                            normal: {
                                fontFamily: 'microsoft yahei',
                                fontWeight: 'bold',
                                color: ()=>{
                                    let currColor = PIE_COLORS[colorIndex % PIE_COLORS.length];

                                    colorIndex++;
                                    return currColor;
                                }
                            },
                            emphasis: {
                                shadowBlur: 10,
                                shadowColor: '#ff0000'
                            }
                        },
                        data: data
                    }]
                });
            },
            async init() {
                await this.getInitChartData();
                await this.initSexBar();
                await this.initChart1();
                await this.initChart2();
                await this.initChart3();
                await this.initChart4();
            },
            // 初始化性别的条
            initSexBar() {
                let {sexCount} = this.pageData;
                let [female, male] = sexCount;
                let count = sexCount.reduce((total, curr) => total + curr.num, 0);

                this.sexData = {
                    manPerc: ((male.num / count) * 100).toFixed(2) + '%',
                    womenCount: female.num,
                    manCount: male.num,
                    womenPerc: ((female.num / count) * 100).toFixed(2) + '%'
                }

            },
            getPieOption(data, type) {
                let seriesData = [],
                    option = {},
                    baseData = {},
                    count = 0,
                    currCount = 0,
                    i, j;

                count = data.reduce((total, curr) => total + curr.num, 0);
                seriesData = data.map(item => {
                    item.value = item.num;
                    baseData[item.name] = ((item.value / count) * 100).toFixed(2) + '%';
                    return item;
                })
                option = {
                    color: PIE_COLORS,
                    legend: {
                        textStyle: {
                            color: TEXT_COLOR,
                            fontSize: 12,
                            width: '50%',
                            rich: {}
                        },
                        top: type == 2 ? '60%' : '65%',
                        bottom: 0,
                        formatter(name) {
                            return name + "  " + baseData[name] + ' ';
                        },
                        itemWidth: 6,
                        itemGap: type == 2 || type == 4 ? 6: 15,
                        icon: "circle",
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} : {c} ({d}%)"
                    },
                    series: [{
                        type: 'pie',
                        center: ['50%', '35%'],
                        radius: type ? ['30%', '50%'] : [0, '55%'],
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };
                return option;
            },
            initChart1() {
                const chart = echarts.init(document.getElementById("chart1"));
                const {ageCount} = this.pageData;

                chart.setOption(this.getPieOption(ageCount, 1), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2() {
                const chart = echarts.init(document.getElementById("chart2"));
                const {partyCount} = this.pageData;

                chart.setOption(this.getPieOption(partyCount, 2), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3() {
                const chart = echarts.init(document.getElementById("chart3"));
                const {educationCount} = this.pageData;

                chart.setOption(this.getPieOption(educationCount, 1), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4() {
                const chart = echarts.init(document.getElementById("chart4"));
                const {executiveLevelCount} = this.pageData;

                chart.setOption(this.getPieOption(executiveLevelCount, 4), true);
                chart.resize();
                this.$winResize(chart.resize);
            }
        }
    }
</script>
<style lang="scss" scoped>
    $baseBgUrl: "~@/assets/images/xhqj/cyqk/";

    .inner {

        > div {
            height: 95.83%;

            &.inner-right {
                float: right;
            }

            &.inner-left {
                float: left;
            }

            &.inner-center {
                margin: 0 30.1%;

                .member-count-block {
                    height: 14.24%;
                    background: url("#{$baseBgUrl}member-count-bg.png") no-repeat center/100% 100%;
                    margin: 0 0.25rem;
                    text-align: center;

                    .item {
                        width: auto;
                        text-align: center;
                        font-weight: bold;
                        line-height: 1;
                        margin-top: 6%;
                        display: inline-block;
                        &:nth-of-type(2) {
                            margin: 0 0.81rem;
                        }

                        dt {
                            font-size: 0.2rem;
                            margin-bottom: 0.14rem;
                            color: #4260FF;
                        }

                        dd {
                            font-size: 0.3rem;
                            color: #B5C8FF;
                        }
                    }
                }

                .sex-ratio {
                    padding-top: 2.4%;
                    height: 30.76%;
                    background: url("#{$baseBgUrl}mountain-bg.png") no-repeat center/68.478% 78.92%;
                    position: relative;

                    &-main {
                        height: 33.215%;
                        border: 1px solid #344DD5;
                        background-color: #131948;
                        padding: 0.06rem 0;
                        position: absolute;
                        bottom: 0;
                        left: 0.45rem;
                        right: 0.45rem;

                        .sex-name {
                            background: no-repeat center/auto 100%;
                            width: 1.32rem;
                            height: 1.3rem;
                            position: absolute;
                            top: -0.06rem;
                            display: block;
                            z-index: 10;

                            &.male {
                                left: -0.8rem;
                                background-image: url("#{$baseBgUrl}male.png");
                            }

                            &.female {
                                right: -0.8rem;
                                background-image: url("#{$baseBgUrl}female.png");
                            }

                        }

                        .sex-ratio-bar {
                            position: absolute;
                            width: 100%;
                            top: 0.06rem;
                            bottom: 0.06rem;

                            .number {
                                font-weight: bold;
                                z-index: 11;
                                position: absolute;
                                top: 0;
                                margin-top: 2%;
                                line-height: 1;

                                .count {
                                    font-size: 0.36rem;
                                    margin-bottom: 0.1rem;
                                }

                                .ratio {
                                    font-size: 0.24rem;
                                    color: #360B23;
                                }
                            }

                            .ratio-bar {
                                height: 100%;
                                overflow: hidden;
                                position: absolute;
                            }

                            .man-radio {
                                position: absolute;
                                left: 0;
                                width: 100%;
                                top: 0;
                                height: 100%;

                                .indictor-light {
                                    content: "";
                                    width: 0.6rem;
                                    height: 100%;
                                    position: absolute;
                                    left: 60%;
                                    z-index: 12;
                                    margin-left: -0.3rem;
                                    background: url("#{$baseBgUrl}light.png") no-repeat center/contain;
                                }

                                .ratio-bar {
                                    width: 60%;
                                    height: 100%;
                                    overflow: hidden;

                                    &-main {
                                        width: 2000px;
                                        height: 100%;
                                        background-image: repeating-linear-gradient(135deg, #0078FF 0, #0078FF 2px, #344DD5 2px, #344DD5 8px, #0078FF 8px, #0078FF 12px);
                                    }
                                }

                                .number {
                                    margin-left: 0.2rem;
                                }
                            }

                            .female-radio {
                                $color1: #FB058F;
                                position: absolute;
                                right: 0;
                                width: 100%;
                                top: 0;
                                height: 100%;

                                .ratio-bar {
                                    width: 40%;

                                    right: 0;

                                    &-main {
                                        width: 600px;
                                        height: 100%;
                                        position: absolute;
                                        right: 0;
                                        background-image: repeating-linear-gradient(135deg, #FB058F 0, #FB058F 2px, change-color($color1, $alpha: 0.8) 2px, change-color($color1, $alpha: 0.8) 8px, #FB058F 8px, #FB058F 12px);
                                    }
                                }

                                .number {

                                    right: 0.2rem;
                                    text-align: right;
                                }
                            }
                        }

                    }
                }

                .professional-block {
                    margin: 4.3% 0 0;
                    height: 53.65%;

                    .professional-main {
                        width: 100%;
                        height: 100%;
                        position: relative;
                        background: url("#{$baseBgUrl}professor-bg.png") no-repeat center/contain;

                        .title {
                            font-size: 0.18rem;
                            position: absolute;
                            line-height: 1;
                            color: #B5C8FF;
                            text-align: center;
                            top: 0.43rem;
                            left: 50%;
                            margin-left: -1em;
                        }

                        .canvas-con {
                            position: absolute;
                            width: 80%;
                            left: 10%;
                            height: 80%;
                            top: 12%;
                            .chart{
                                width:100%;
                                height:100%;
                            }
                        }
                    }

                }
            }
        }

    }

    .battery-block {
        width: 28.69%;
        position: relative;

        &:before,
        &:after {
            position: absolute;
            top: 0.5rem;
            bottom: 0.5rem;
        }

        &:before,
        &:after {
            content: "";
            width: 0.45rem;
            background: no-repeat center/100% 100%;
        }

        &:before {
            left: -0.05rem;
            transform: rotate(180deg);
            background-image: url("#{$baseBgUrl}battery-decoration.png");
        }

        &:after {
            right: -0.05rem;
            background-image: url("#{$baseBgUrl}battery-decoration.png");
        }

        &-main {
            position: absolute;
            top: 0;
            bottom: 0;
            background-repeat: no-repeat;
            background-image: url("#{$baseBgUrl}battery-bg.png");
            background-size: 100% 100%;
            background-position: center;
            left: 0.3rem;
            right: 0.3rem;
            background-color: #0F1333;
            border-top: none;
            border-bottom: none;

            &:before,
            &:after {
                content: "";
                position: absolute;
                background: no-repeat center/contain;
            }

            &:before {
                background-image: url("#{$baseBgUrl}battery-icon-1.png");
                width: 0.84rem;
                height: 0.5rem;
                right: 0.2rem;
                top: 0.2rem;
            }

            &:after {
                background-image: url("#{$baseBgUrl}battery-icon-2.png");
                width: 0.42rem;
                height: 0.44rem;
                left: 0.4rem;
                bottom: 0.4rem;
            }

            .battery-block-main-con {
                padding-top: 0.83rem;
                height: 100%;
            }

            .chart-con {
                height: 50%;

                .chart-title {
                    position: relative;
                    width: 100%;
                    height: 0.4rem;

                    .chart-title-main {
                        width: 43%;
                        height: 100%;
                        background: url("#{$baseBgUrl}battery-title-bg.png") no-repeat center/cover;
                        margin: 0 auto;
                        font-size: 0.16rem;
                        text-align: center;
                        line-height: 0.4rem;
                        color: #B5C8FF;
                    }

                    &:before,
                    &:after {
                        content: "";
                        width: 26.36%;
                        height: 0.33rem;
                        position: absolute;
                        background: no-repeat center top/100% 100%;
                    }

                    &:before {
                        top: 0;
                        left: 2.23%;
                        background-image: url("#{$baseBgUrl}battery-title-line-l.png");
                    }

                    &:after {
                        right: 2.23%;
                        bottom: 0;
                        background-image: url("#{$baseBgUrl}battery-title-line-r.png");
                    }
                }

                .chart-con-main {
                    width: 84.78%;
                    margin: -0.8rem auto 0;
                    height: 100%;
                    padding-top: .8rem;
                    background: url("#{$baseBgUrl}battery-chart-bg.png") no-repeat center/contain;

                    .chart {
                        width: 100%;
                        height: 100%;
                    }
                }

            }

        }

    }
</style>